import { ITag, MaybeUndef } from '@models/Tag.model';
import ReactTooltip from 'react-tooltip';

import { Container, Label, TagBody } from './TagLabel.styles';

type NeededTagProperties = Pick<ITag, 'name'> & {
  tagCategory: MaybeUndef<
    Pick<NonNullable<ITag['tagCategory']>, 'color' | 'id' | 'name'>
  >;
};
export interface ITagLabelProps {
  onClick?: () => void;
  active?: boolean;
  tag: NeededTagProperties;
  haveBottomMargin?: boolean;
  removeMaxWidth?: boolean;
}

const TagLabel = ({
  active,
  onClick,
  tag,
  haveBottomMargin,
  removeMaxWidth,
}: ITagLabelProps) => {
  return (
    <Container
      color={tag.tagCategory?.color}
      data-for={`helpTooltip ${tag.tagCategory?.id}`}
      data-tip
      onClick={onClick}
      active={!!active}
      haveBottomMargin={haveBottomMargin}
    >
      <TagBody active={!!active} removeMaxWidth={removeMaxWidth}>
        <Label active={!!active}>{tag.name}</Label>
      </TagBody>

      <ReactTooltip
        id={`helpTooltip ${tag.tagCategory?.id}`}
        multiline
        className="tooltip"
        effect="solid"
      >
        {`Category: ${tag.tagCategory?.name}`}
      </ReactTooltip>
    </Container>
  );
};

TagLabel.defaultProps = {
  onClick: () => {},
  active: false,
};

export { TagLabel }; //
